import type { INotificationService, SendEmailRequest } from '../interface/INotificationService';
import type { IHttpWrapperService } from '../interface/IHttpWrapperService';
import type { AxiosResponse } from 'axios';
import type { ApiResponse } from '../../models/ApiResponse';
import { isSuccessResponse } from '../../models/ApiResponse';

/**
 * Service for managing notification operations
 */
export class NotificationService implements INotificationService {

  /**
   * Sends an email notification
   * @param request - The email request data
   * @returns Promise<void> - Resolves when email is sent successfully
   */
  public sendEmail = async (request: SendEmailRequest): Promise<void> => {
    try {
      const { container, TYPES } = await import('../inversify.config');
      const httpService = container.get<IHttpWrapperService>(TYPES.IHttpWrapperService);

      const endpoint = 'notification/sendemail';

      const response: AxiosResponse<any> = await httpService.postRequest<any, SendEmailRequest>(endpoint, request);

      // Check if it's a successful HTTP status code (200-299)
      if (response.status >= 200 && response.status < 300) {
        // If response has the expected ApiResponse structure, validate it
        if (response.data && typeof response.data === 'object' && 'isSuccess' in response.data) {
          if (!isSuccessResponse(response.data)) {
            throw new Error(response.data.message || 'Failed to send email notification');
          }
        }
        // If it's just a 200 status without ApiResponse structure, consider it successful
        return;
      } else {
        throw new Error(`HTTP ${response.status}: Failed to send email notification`);
      }
    } catch (error) {
      throw error;
    }
  };
}